import React from 'react';
import { useNavigate } from 'react-router-dom';
import { searchContext } from '../../Context/Context.jsx';
import { SearchButtonProps, SearchContext } from '../../types.js';
import { DATASETS } from '../../Components/Constants.jsx';
import SharedButton from '../Button/Button';

export default function SearchButton({
  setValue,
  className = '',
  children = 'Search',
  variant = 'primary',
  size = 'md',
  iconLeft,
  iconRight,
  id,
  hasImg,
  imgSrc,
}: SearchButtonProps) {
  const navigate = useNavigate();
  const { searchItems } = searchContext() as unknown as SearchContext;

  const handleSubmit = (evt: React.MouseEvent) => {
    evt.preventDefault();

    let idents = 'ALL';
    let view = 'ALL';
    let tab = 'GDA';

    if (searchItems!.length > 0) {
      idents = searchItems!.map(item => item.id).join('-');
      view = searchItems![0].dataset;
      tab = view === DATASETS.VARIANTS ? 'VDA' : 'GDA';
    }

    navigate({
      pathname: '/search',
      search: `?view=${view}&idents=${idents}&source=ALL&tab=${tab}`,
    });

    setValue('');
  };

  return (
    <>
      {hasImg ? (
        <img
          id={id as string}
          src={imgSrc}
          alt="Search Button"
          className={className}
          onClick={handleSubmit}
          role="button"
          tabIndex={0}
          style={{ zIndex: 10 }}
        />
      ) : (
        <SharedButton
          id={id as string}
          onClick={handleSubmit}
          className={className}
          variant={variant}
          size={size}
          iconLeft={iconLeft}
          iconRight={iconRight}
        >
          {children}
        </SharedButton>
      )}
    </>
  );
}
